
  <div class="header-bar">
    <a href="https://www.mirrormedia.mg/" target="_blank">
      <svg height="82" viewBox="0 0 82 82" width="82" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd" transform="translate(1 1)"><g fill={iconColor}><path d="m40.1795918.35918367c-21.9922041 0-39.82040813 17.82820403-39.82040813 39.82040813 0 21.9922042 17.82820403 39.8204082 39.82040813 39.8204082 21.9922042 0 39.8204082-17.828204 39.8204082-39.8204082-.0269872-21.981016-17.8393922-39.79342097-39.8204082-39.82040813zm0 78.31836733c-21.2618357 0-38.49795915-17.2361234-38.49795915-38.4979592 0-21.2618357 17.23612345-38.49795915 38.49795915-38.49795915 21.2618358 0 38.4979592 17.23612345 38.4979592 38.49795915-.0224966 21.2525104-17.2454488 38.4754626-38.4979592 38.4979592z" fill-rule="nonzero"/><path d="m23.8938776 58.7755102c.795854-.8867081 1.2652626-2.0184723 1.3306122-3.2081633v-4.8081632c0-1.0367347 0-1.877551 0-1.877551l-1.3306122 1.3306122-2.4081633 2.4081633c-.7958541.8867081-1.2652627 2.0184723-1.3306123 3.2081632v4.8408164 1.877551l1.3387756-1.322449z"/><circle cx="35.659857" cy="53.94797" r="3.387755" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -27.702445 41.016321)"/><path d="m38.7836735 66.3591837c.3412229-.6437416.5651239-1.3430867.6612245-2.0653061h-7.1755102v-17.1428572h7.0448979v-3.0693877c.0749959-.5620209-.1210627-1.1262972-.5283821-1.520737s-.977602-.5722725-1.536924-.479263h-4.9795918v-5.0367347h7.1673469s0-.8163266 0-1.8775511v-3.4204081c-.0703549-1.1772899-.5363643-2.2962878-1.322449-3.1755102l-6.9142857-6.9142857c-.7357746-.7327062-1.9254498-.7327062-2.6612245 0l-6.9306122 6.9142857c-.7958541.8867081-1.2652627 2.0184723-1.3306123 3.2081632v3.322449 1.8938776c0 .0081632.6122449-.5877551 1.3387755-1.3142857l6.9551021-6.8816327c.7357746-.7327062 1.9254498-.7327062 2.6612245 0l3.1673469 3.1673469h-5.6816327c-1.0629647.033462-2.0671156.4957837-2.7836734 1.2816327l-4.367347 4.3673469h5.6326531v4.4979592h-7.0530612v3.167347c-.0557067.5329005.1373845 1.0617231.5233647 1.4333486.3859801.3716255.9217377.5445458 1.4521455.4686922h5.0693877v17.1428571h-7.0448979s1.632653 5.077551 4.6122449 5.077551h9.7959183c.2745485-.0004497.548245-.0305563.8163266-.0897959 1.241568-.4482312 2.3080872-1.2802877 3.0448979-2.3755102l.0653062-.0979592c.0734693-.1061224.1306122-.2122449.1959183-.3265306z"/><path d="m60.4081633 57.3306122h5.0938775v-18.5959183h-24.4897959v16.0244898s-.0734694 2.5632653 2.4489796 2.5632653h2.6367347v6.9714286h-4.9795919c-.1946781 1.9408962-1.0779214 3.747925-2.4897959 5.0938775h7.6653062c5.0612244 0 4.8408163-4.8979592 4.8408163-4.8979592v-7.1591837h4.2204081v12.0571429h4.8571429c3.1346939 0 6.7265306-5.0938775 6.7265306-5.0938775h-6.5306122zm-3.1183674-5.0857142c-2.272095 2.2106568-5.8911703 2.2106568-8.1632653 0h-3.0204082v-8.4489796h3.0693878c2.272095-2.2106569 5.8911703-2.2106569 8.1632653 0h3.1673469v8.4489796z" fill-rule="nonzero"/><path d="m43.1265306 37.044898h22.4081633c0-.9387756 0-2.1142858 0-3.1346939 0-2.0979592-2.2612245-1.9428572-2.2612245-1.9428572h-1.5510204v-5.0693877h3.8040816v-2.7755102c.0303863-.6450159-.2236106-1.2709132-.6948915-1.7123463-.4712808-.4414331-1.1124356-.6539945-1.7540881-.5815313h-7.2734694v-2.3102041h-5.0693877v2.3020409h-9.7306123v3.3959183s-.0734694 1.6816327 2.1469388 1.6816327h1.6326531v5.077551h-3.7795919v3.2653061c.0162036.5305678.2562342 1.0294844.6606831 1.373266s.9355182.5002998 1.4617659.4308157zm6.7591837-10.1469388h6.7673469v5.077551h-6.7673469z" fill-rule="nonzero"/><path d="m53.1346939 43.6408163c-2.4480867 0-4.4326531 1.9845664-4.4326531 4.4326531s1.9845664 4.432653 4.4326531 4.432653 4.432653-1.9845663 4.432653-4.432653-1.9845663-4.4326531-4.432653-4.4326531zm0 7.4693878c-1.6726338 0-3.0285715-1.3559376-3.0285715-3.0285714 0-1.6726339 1.3559377-3.0285715 3.0285715-3.0285715s3.0285714 1.3559376 3.0285714 3.0285715c-.0044999 1.6694449-1.3591204 3.0204142-3.0285714 3.0204081z" fill-rule="nonzero"/><circle cx="53.134694" cy="48.073469" r="2.816327"/></g><circle cx="40" cy="40" r="39.183674" stroke={iconColor} stroke-width="2.4"/></g>
      </svg>
    </a>
    <div class="header-bar__wrapper">
      <svg on:click={() => { dispatch('open') }} class="menu" height="80" viewBox="0 0 80 80" width="80" xmlns="http://www.w3.org/2000/svg"><path d="m19.2851318 26.0317678 41.5148682-.4317678-.0851318 4.3682322-41.5148682.4317678zm0 12.8 41.5148682-.4317678-.0851318 4.3682322-41.5148682.4317678zm0 12.8 41.5148682-.4317678-.0851318 4.3682322-41.5148682.4317678zm20.7148682 28.3682322c-22.09139 0-40-17.90861-40-40s17.90861-40 40-40 40 17.90861 40 40-17.90861 40-40 40zm0-2.3300971c20.8045129 0 37.6699029-16.86539 37.6699029-37.6699029s-16.86539-37.66990291-37.6699029-37.66990291-37.66990291 16.86539001-37.66990291 37.66990291 16.86539001 37.6699029 37.66990291 37.6699029z" fill={iconColor}/></svg>
      <div class="share" class:active={isShare} on:click|stopPropagation={toggleShare}>
        <svg height="80" viewBox="0 0 80 80" width="80" xmlns="http://www.w3.org/2000/svg"><path d="m27.4295484 47.2371943c-1.4178351 1.5206624-3.4388602 2.4715436-5.6819756 2.4715436-4.2895903 0-7.7669903-3.4774-7.7669903-7.7669903s3.4774-7.7669903 7.7669903-7.7669903c1.9004041 0 3.6413973.6825193 4.9912284 1.8158068l17.1525071-10.2340339c-.2569958-.7717903-.3961627-1.5974227-.3961627-2.4555593 0-4.2895903 3.4774-7.7669903 7.7669903-7.7669903s7.7669903 3.4774 7.7669903 7.7669903-3.4774 7.7669903-7.7669903 7.7669903c-1.9276046 0-3.6912023-.702197-5.0489477-1.8647454l-17.1182554 10.2135977c.2719808.7916137.4196303 1.6410312.4196303 2.5249341 0 .5513013-.0574382 1.0891872-.1666569 1.6079998l16.5421256 9.8698502c1.3950622-1.3363756 3.2876957-2.1574617 5.3721041-2.1574617 4.2895903 0 7.7669903 3.4774 7.7669903 7.7669903s-3.4774 7.7669903-7.7669903 7.7669903-7.7669903-3.4774-7.7669903-7.7669903c0-.7074859.0945929-1.3928784.2718213-2.0442201zm12.5704516 32.7628057c-22.09139 0-40-17.90861-40-40s17.90861-40 40-40 40 17.90861 40 40-17.90861 40-40 40zm0-2.3300971c20.8045129 0 37.6699029-16.86539 37.6699029-37.6699029s-16.86539-37.66990291-37.6699029-37.66990291-37.66990291 16.86539001-37.66990291 37.66990291 16.86539001 37.6699029 37.66990291 37.6699029z" fill={iconColor}/></svg>
        <div class="icon icon--fb" on:click|stopPropagation={shareToFb}/>
        <div class="icon icon--line" on:click|stopPropagation={shareToLine}/>
      </div>
    </div>
  </div>


<svelte:window on:scroll={raf(changeIconColor)} on:click={closeShare} />

<script>
import { onMount, createEventDispatcher } from 'svelte'
import { raf } from '../util/index.js'

const dispatch = createEventDispatcher()

let game = null
let listContent = null
onMount(function () {
  game = document.getElementById('game')
  listContent = document.getElementById('list-content')
})

let iconColor = '#fff'
function changeIconColor () {
  const gameT = game.getBoundingClientRect().top
  const listContentT = listContent.getBoundingClientRect().top

  iconColor = (gameT <= 0 && listContentT > 0) ? '#5c7886' : '#fff'
}

let isShare = false
function toggleShare () {
  isShare = !isShare
}
function shareToFb () {
  window.open('https://www.facebook.com/share.php?u=https://www.mirrormedia.mg/projects/taiwansocialworker/')
}
function shareToLine () {
  window.open('https://line.me/R/msg/text/?https://www.mirrormedia.mg/projects/taiwansocialworker/')
}

function closeShare () {
  isShare = false
}
</script>

<style lang="scss">.header-bar {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box; }
  @media (min-width: 768px) {
    .header-bar {
      padding-top: 20px;
      padding-left: 20px;
      padding-right: 20px; } }
  .header-bar__wrapper {
    display: flex; }

svg, .icon {
  width: 30px;
  height: 30px;
  display: block;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none; }
  @media (min-width: 768px) {
    svg, .icon {
      width: 50px;
      height: 50px; } }

.menu {
  margin-right: 10px; }

.share {
  position: relative; }
  .share .icon {
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    background-size: 30px 30px;
    opacity: 0;
    z-index: -1;
    transition: all 0.3s ease-in-out; }
    @media (min-width: 768px) {
      .share .icon {
        background-size: 50px 50px; } }
    .share .icon--fb {
      background-image: url(../assets/share-fb.svg); }
    .share .icon--line {
      background-image: url(../assets/share-line.svg); }
  .share.active .icon {
    opacity: 1; }
    .share.active .icon--fb {
      transform: translateY(40px); }
      @media (min-width: 768px) {
        .share.active .icon--fb {
          transform: translateY(60px); } }
    .share.active .icon--line {
      transform: translateY(80px); }
      @media (min-width: 768px) {
        .share.active .icon--line {
          transform: translateY(120px); } }
/*# sourceMappingURL=src/components/HeaderBar.svelte.map */</style>
